import(/* webpackMode: "eager" */ "/vercel/path0/website/src/app/page.tsx");
